import React, { useMemo } from 'react';
import { Button, IconButton, Typography, useOverlayContext } from 'seagull';
import BillServiceModal from "../../BillServiceModal/BillServiceModal";
import styles from "../ServicesSection.module.scss";
import { billableStateModel, serviceBillingModel } from "../../../../../models";
import { Intent } from "../../../../../infra/access-control";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import BillClientModal from "../../../../../components/BillClientModal/BillClientModal";
import { createEmptyServiceItem } from "../../../../../components/BillClientModal/BillClientItem.utils";
import { Map } from 'seagull/icons';
import { getQboTooltip } from "./ServiceBillingItem.utils";
import UnbilledTimeActivities from "./UnbilledTimeActivities";
const nonBillableReasonToTooltip = {
  issuingInvoice: 'An invoice is being issued. Please wait',
  billedMaxCharges: 'This service was already billed the maximum number of times'
};
export default function ManualServiceBillingItem(props) {
  const {
    name,
    costDisplay,
    unitCapDisplay,
    service,
    idx,
    agreement,
    invoiceDateInfo,
    earliestBillableDate,
    controlData,
    qboItemName,
    qboClassName,
    serviceTimeActivities
  } = props;
  const overlayContext = useOverlayContext();
  const {
    BILL_CLIENT,
    BILLING_CONTROL_MAP_CALLOUT,
    TIME_ACTIVITIES,
    MAX_CHARGES_ADDED
  } = useFeatureFlags();
  const {
    manualServices,
    totalCredits
  } = controlData;
  const maxCharges = serviceBillingModel.maxCharges(service.billing);
  const nonBillableReason = useMemo(() => {
    const manualServiceBilling = manualServices[service.id];
    return manualServiceBilling !== null && manualServiceBilling !== void 0 && manualServiceBilling.billableState ? billableStateModel.nonBillableReason(manualServiceBilling.billableState) : null;
  }, [manualServices, service.id]);
  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceName
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "name"
  }, name), BILLING_CONTROL_MAP_CALLOUT && qboItemName && /*#__PURE__*/React.createElement(IconButton, {
    tooltip: {
      placement: 'top',
      title: getQboTooltip(qboItemName, qboClassName)
    },
    noPadding: true,
    size: "small",
    skin: "primaryTransparent",
    "data-testid": "maunal-service-qbo-synced-".concat(service.id),
    cursorDefault: true
  }, /*#__PURE__*/React.createElement(Map, {
    className: styles.mapIcon,
    "data-testid": "map-icon-".concat(service.id)
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.cost
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay), unitCapDisplay && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "unit-cap",
    variant: "paragraph2",
    skin: "secondary"
  }, unitCapDisplay)), MAX_CHARGES_ADDED && (maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.enabled) && maxCharges.limit && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "max-charges-added-indicator",
    variant: "paragraph2",
    skin: "secondary"
  }, maxCharges.limit - (maxCharges.chargesLeft || 0), "/", maxCharges.limit, " times added")), /*#__PURE__*/React.createElement(UnbilledTimeActivities, {
    service: service,
    TIME_ACTIVITIES: TIME_ACTIVITIES,
    serviceTimeActivitiesLength: serviceTimeActivities.length
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    intent: Intent.Bill,
    "data-testid": "billing-control-manual-bill-".concat(service === null || service === void 0 ? void 0 : service.id),
    "data-reason": nonBillableReason || '',
    disabled: nonBillableReason != null,
    tooltip: nonBillableReason != null ? {
      placement: 'top',
      title: nonBillableReasonToTooltip[nonBillableReason]
    } : undefined,
    onClick: () => {
      overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref => {
          let {
            dismissModal
          } = _ref;
          return BILL_CLIENT ? /*#__PURE__*/React.createElement(BillClientModal, {
            dismissModal: dismissModal,
            defaultItem: createEmptyServiceItem(service),
            manualServicesBilling: manualServices,
            invoiceDateInfo: invoiceDateInfo,
            relationship: agreement,
            totalCredits: totalCredits,
            earliestBillableDate: earliestBillableDate,
            controlData: controlData
          }) : /*#__PURE__*/React.createElement(BillServiceModal, {
            serviceWithAmendments: service,
            invoiceDateInfo: invoiceDateInfo,
            relationship: agreement,
            dismissModal: dismissModal,
            manualServicesBilling: manualServices,
            totalCredits: totalCredits,
            earliestBillableDate: earliestBillableDate
          });
        }
      });
    }
  }, "Bill")));
}